<template>
    <div class="py-5 my-5 result-parent">
        <div class="results-container px-5">
            <div class="results-container-child text-center">
                <div class="result-entity mx-4 wpm-container bg-cyan py-4 rounded-cust fadeInUp">
                    <h1 class="py-2">Typing Speed</h1>
                    <span class="larger">{{getTypingStats.finalWpm}}</span> <span class="small"> WPM</span>
                </div>
                <div class="result-entity mx-4 acc-container bg-green py-4 rounded-cust fadeInUp">
                    <h1 class="py-2">Accuracy</h1>
                    <span class="larger">{{getTypingStats.accuracy}}</span><span class="small"> %</span>
                </div>
                <div class="result-entity mx-4 acc-container bg-red py-4 rounded-cust fadeInUp">
                    <h1 class="py-2">Time</h1>
                    <span class="larger">{{getTypingStats.totalMinsTaken}}</span><span class="small"> mins</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: "Result",
    props: {
        typingStats: Object
    },
    computed: {
        getTypingStats() {
            return this.typingStats;
        }
    },
}
</script>

<style lang="scss">
    .result-parent {

        .larger {
            font-size: 45px;
            font-weight: 600;
        }

        .small {
            font-size: 22px;
            font-weight: 600;
            opacity: 0.5;
        }

        .results-container-child {
            display: flex;
            justify-content: center;
            flex-direction: row;

            @media only screen and (max-width: 950px) {
                flex-direction: column;
                align-items: center;
                .result-entity {
                    margin: 15px auto;
                }
            }
        }

        .result-entity {
            width: 300px;
        }
    }
</style>